import React from 'react'
import PropTypes from 'prop-types'
import { AddMemberBankAccountForm } from '../../shared/components'

const AddMemberBankAccountComponent = ({ onSubmit }) => {
  return (
    <AddMemberBankAccountForm header="Add bank account" onSubmit={onSubmit} />
  )
}

AddMemberBankAccountComponent.propTypes = {
  onSubmit: PropTypes.func.isRequired,
}

export default AddMemberBankAccountComponent
